import "./orderDetails.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Alert,
  Backdrop,
  Button,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import { db } from "../../firebase";
import { deleteDoc, doc, getDoc } from "firebase/firestore";
import Navbar from "../../components/navbar/Navbar";
import { ContentCopyOutlined } from "@mui/icons-material";
import { ModalComponentDelete } from "../../components/modal";

const OrderDetails = () => {
  const { orderId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const retrievedData = window.myData;
  const userId = state?.userID || retrievedData?.userID;

  const [openToast, setOpenToast] = useState(false);
  const [openLoading, setDialogLoading] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [isDataAvailable, setDataAvailable] = useState(false);
  const [isPaymentAvailable, setPaymentAvailable] = useState(false);
  const [ordersData, setOrdersData] = useState({});
  const [orderPaymentData, setOrderPaymentData] = useState({});
  const [publishedOn, setPublishedOn] = useState();
  const [errorMessage, setErrorMessage] = useState(
    "Something went wrong.\nPlease try again"
  );
  useEffect(async () => {
    try {
      if (userId) {
        const userref = doc(db, "Users", userId, "Library", orderId);
        const docSnap = await getDoc(userref);

        if (docSnap.exists()) {
          const euserData = docSnap.data();
          const userDataWithId = { ...euserData, id: docSnap.id };

          console.log(docSnap.data().createTime);
          const paymentID = euserData.payment_UID;
          document.title = "Order - " + euserData.name;
          setOrdersData(userDataWithId);

          if (paymentID !== "Free") {
            const paymentRef = doc(db, "Users", userId, "Payments", paymentID);
            const paymentSnap = await getDoc(paymentRef);

            const publishDate = paymentSnap.data().timestamp
              ? paymentSnap.data().timestamp.toDate()
              : null;
            setPublishedOn(publishDate);
            setOrderPaymentData(paymentSnap.data());
            setPaymentAvailable(true);
          }
          setDataAvailable(true);
          setLoading(false);
        } else {
          setLoading(false);
          setErrorMessage("There is no such user available. Please try again.");
        }
      } else {
        setLoading(false);
        setErrorMessage(
          "Link has been broken. Please close this tab or repon this page from the order list."
        );
      }
    } catch (error) {
      setLoading(false);
      setErrorMessage("Error - " + error);
    }
  }, []);
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "Not available";

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    return timestamp.toLocaleDateString("en-US", options);
  };
  const handleCopiedTextClick = () => {
    navigator.clipboard.writeText(ordersData.pdf_password);
    setOpenToast(true);
  };

  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleDeleteOrder = async () => {
    setDialogLoading(true);
    try {
      const userOrderref = doc(db, "Users", userId, "Library", orderId);
      if (isPaymentAvailable) {
        const paymentID = ordersData.payment_UID;
        const paymentRef = doc(db, "Users", userId, "Payments", paymentID);
        await deleteDoc(paymentRef);
      }
      await deleteDoc(userOrderref);
      setDialogLoading(false);
      alert("Deleted Successfully");
      navigate(-1);
    } catch (error) {
      setDialogLoading(false);
      alert(error.message);
    }
  };

  return (
    <div className="list">
      <ModalComponentDelete
        title={"Confirmation"}
        body={
          "Please confirm if you wish to proceed with deleting this order. This action will permanently remove it from the order's list."
        }
        cancelBtnText={"No"}
        primaryBtnText={"Yes"}
        primaryClick={handleDeleteOrder}
        modalID={"orderDialog"}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openToast}
        autoHideDuration={3000}
        onClose={handleToastClose}
      >
        <Alert
          onClose={handleToastClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Copied!
        </Alert>
      </Snackbar>
      <Sidebar />
      <div className="listContainer">
        {isLoading && (
          <div className="intialItem">
            <CircularProgress />
          </div>
        )}
        {!isLoading && !isDataAvailable && (
          <div className="intialItem">{errorMessage}</div>
        )}
        {!isLoading && isDataAvailable && (
          <div>
            <Navbar />
            <div className="top">
              <div className="left">
                {/*<div className="editButton">Edit</div>*/}
                <div>
                  <h1 className="title">Order Details</h1>
                  <div className="item">
                    <div className="leftSection">
                      <img
                        src={ordersData.thumbImage}
                        alt=""
                        className="itemImg"
                      />
                      <div className="viewPDF">
                        <img
                          src="https://th.bing.com/th/id/OIP.zk2laqbASpdFh90T27XngAHaF2?w=247&h=195&c=7&r=0&o=5&dpr=1.5&pid=1.7"
                          className="userOrderPDF"
                        />

                        <a
                          href={ordersData.pdfUrl}
                          target="_blank"
                          style={{ textDecoration: "none" }}
                        >
                          View PDF
                        </a>
                      </div>
                      <div className="viewPDF">
                        <a
                          href={"/users/" + userId}
                          target="_blank"
                          style={{ textDecoration: "none" }}
                        >
                          View User Details
                        </a>
                      </div>
                      <div className="viewPDF">
                        <a
                          href={"/library/" + orderId}
                          target="_blank"
                          style={{ textDecoration: "none" }}
                        >
                          View Book Details
                        </a>
                      </div>
                      <div className="viewPDF">
                        <Button
                          fullWidth
                          color="error"
                          variant="outlined"
                          data-bs-toggle="modal"
                          data-bs-target="#orderDialog"
                        >
                          Delete Order
                        </Button>
                      </div>
                    </div>
                    <div className="details">
                      <h1 className="itemTitle">{ordersData.name}</h1>

                      <div className="detailItem">
                        <span className="itemValue">
                          {ordersData.eType + " | "}
                        </span>
                        <span className="itemValue">
                          {ordersData.pages + " pages"}
                        </span>
                      </div>

                      <div className="detailItem">
                        <span className="itemKey">About:</span>
                        <span className="itemValue">{ordersData.about}</span>
                      </div>

                      <div className="detailItem">
                        <span className="itemKey">Author:</span>
                        <span className="itemValue">{ordersData.author}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Publisher:</span>
                        <span className="itemValue">
                          {ordersData.publisher}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">PDF Password:</span>
                        <span className="itemValue me-2">
                          {ordersData.pdf_password}
                        </span>
                        <ContentCopyOutlined
                          color="primary"
                          fontSize="small"
                          onClick={handleCopiedTextClick}
                        />
                      </div>
                      {!isPaymentAvailable && (
                        <>
                          <hr />
                          <h5>
                            <span className="badge text-bg-success  mb-3">
                              {"Free"}
                            </span>
                          </h5>
                        </>
                      )}
                      {isPaymentAvailable && (
                        <>
                          <hr />
                          <div className="detailItem">
                            <span className="itemKey">ORDER ID:</span>
                            <span className="itemValue">
                              {orderPaymentData.ORDERID}
                            </span>
                          </div>
                          <div className="detailItem">
                            <span className="itemKey">
                              Transaction Merchant ID(Razorpay):
                            </span>
                            <span className="itemValue">
                              {orderPaymentData.TXNID}
                            </span>
                          </div>
                          <div className="detailItem">
                            <span className="itemKey">Transaction Amount:</span>
                            <span className="itemValue">
                              {"₹" + orderPaymentData.TXNAMOUNT}
                            </span>
                          </div>
                          <div className="detailItem">
                            <span className="itemKey">Payment Date:</span>
                            <span className="itemValue">
                              {formatTimestamp(publishedOn)}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderDetails;
